import { TrackerType, Tracker } from '~/models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class Snowplow implements TrackerType {
  id: number = Tracker.TYPE_SNOWPLOW;
  label: string = 'Snowplow';
  isEnabled: boolean = false;
  hasClientId: boolean = false;

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
